import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import * as moment from "moment-timezone";
import { FiltroDatas } from "../../model/filtro-data.model";

export class DashboardItem {
    quantidade: number;
    descricao: string;
    icone: string;
    estilo: 'primary' | 'danger';
}

@Component({
    selector: 'card-dashboard',
    templateUrl: './card-dashboard.component.html',
    styleUrls: ['./card-dashboard.component.scss']
})
export class CardDashboardComponent implements OnInit {
    @Input() itens: DashboardItem[] = [];
    protected dataInicio: moment.Moment;
    protected dataFinal: moment.Moment;

    @Output() filtroDataChange = new EventEmitter<FiltroDatas>();

    ngOnInit(): void {
        if (!this.itens || this.itens.length < 1 || this.itens.length > 3) {
            throw new Error('O CardDashboardComponent requer de 1 a 3 itens no máximo.');
        }
    }

    protected setDataInicio(): void {
        this.emitirFiltroDatas();
    }

    protected setDataFim(): void {
        this.emitirFiltroDatas();
    }

    protected limparFiltroStatus(): void {
        this.dataFinal = undefined;
        this.dataInicio = undefined;
        this.emitirFiltroDatas();
    }
    private emitirFiltroDatas(): void {
        this.filtroDataChange.emit({
            dataInicio: this.dataInicio,
            dataFinal: this.dataFinal
        });
    }
}
